import { Routes } from '@angular/router';
import { authGuard } from 'app/guards/auth/auth-guard';
import { roleGuard } from 'app/guards/role/role-guard';

// Define routes specific to the owner role
export const ownerRoutes: Routes = [
    {
        path: 'homepage',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/homepage/homepage').then(m => m.Homepage),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'properties',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/property/property-list/property').then(m => m.Property),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'property-details/:propertyId',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/property/property-detail/property-detail').then(m => m.PropertyDetail),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'tenants',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/tenant/tenant').then(m => m.Tenant),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'payments',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/payment/payment').then(m => m.Payment),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'payment-dashboard',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/payment-dashboard/payment-dashboard').then(m => m.PaymentDashboard),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'all-payments',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/all-payments/all-payments').then(m => m.AllPaymentsComponent),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'add-property',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/property/add-property/add-property').then(m => m.AddProperty),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'update-property',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/property/update-property/update-property').then(m => m.UpdateProperty),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'handyman',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/handyman/handyman').then(m => m.Handyman),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'profile',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/owner-profile/owner-profile').then(m => m.OwnerProfile),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'saved-cards',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/saved-cards/saved-cards').then(m => m.SavedCards),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'my-wallet',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/my-wallet/my-wallet').then(m => m.MyWalletComponent),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'referral',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/referral/referral').then(m => m.Referral),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'plans',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/owner-plan/owner-plan').then(m => m.OwnerPlan),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'subscription-history',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/owner-plan/subscription-history/subscription-history').then(m => m.SubscriptionHistory),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'ssn-verification',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/ssn-verification/ssn-verification').then(m => m.SsnVerification),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'update-verification',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/ssn-verification/owner-modification-page/owner-modification-page').then(m => m.OwnerModificationPage),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'tenant-move-out-management',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/tenant-move-out-management/tenant-move-out-management').then(m => m.TenantMoveOutManagement),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'communication',
        canActivate: [authGuard, roleGuard],
        loadComponent: () => import('@pages/owner/owner-communication/owner-communication').then(m => m.OwnerCommunication),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'lease-form',
        canActivate: [authGuard],
        loadComponent: () => import('@pages/owner/lease-form/lease-form').then(m => m.LeaseForm),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
    {
        path: 'notification',
        canActivate: [authGuard],
        loadComponent: () => import('@pages/owner/owner-notification/owner-notification').then(m => m.OwnerNotification),
        data: {
            isHeader: 1,
            isFooter: 1,
            isSidebar: 0,
            isNavbar: 0,
            role: 'owner'
        }
    },
];
